var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiLink = function SvgMultiLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#2DA0FC",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 7.994q0-.563.628-.563h2.508q.404 0 .858-.21.454-.212.895-.55.446-.332.806-.717.366-.384.59-.735l.25-.385a.55.55 0 0 1 .487-.272q.22 0 .384.14t.164.409q0 .239-.145.46l-.16.243q-.215.323-.53.665a8 8 0 0 1-.665.652 6 6 0 0 1-.707.534q-.352.225-.647.32v.018q.294.094.647.319.351.229.707.534.357.309.666.652.315.342.53.67l.159.244a.8.8 0 0 1 .145.454q0 .268-.16.408a.56.56 0 0 1-.388.146.55.55 0 0 1-.488-.277l-.248-.385a5 5 0 0 0-.59-.74 6 6 0 0 0-.807-.717 5 5 0 0 0-.895-.544 2.1 2.1 0 0 0-.858-.206H3.628Q3 8.56 3 7.994M8.71 4.58q-.24-.188-.17-.398.072-.206.376-.296l2.03-.586q.243-.075.407.052.17.131.16.384l-.075 2.114q-.01.32-.197.432-.188.117-.427-.066zm.013 6.75 2.157-1.566q.24-.177.422-.056.187.122.187.44l.005 2.115q0 .258-.174.38-.168.12-.408.042l-2.01-.656q-.3-.094-.366-.31-.06-.215.187-.389"
  })));
};
export default SvgMultiLink;